const SLEUTEL = 'actieveOrganisatie';

/**
 * Houdt bij in welke organisatie de superbeheerder werkt.
 *
 * We doen dit met een header in plaats van via het subdomein, omdat elk subdomein een
 * eigen opslag heeft: je zou bij elke wissel opnieuw moeten inloggen. Met een header
 * blijf je op hetzelfde adres — en dus ingelogd.
 *
 * De server accepteert deze header uitsluitend van een superbeheerder; voor iedereen
 * anders blijft de eigen organisatie leidend.
 */
export const OrganisatieKeuze = {
    get() {
        return localStorage.getItem(SLEUTEL) || '';
    },

    zet(organisatieId) {
        if (organisatieId) {
            localStorage.setItem(SLEUTEL, String(organisatieId));
        } else {
            localStorage.removeItem(SLEUTEL);
        }
    },

    wis() {
        localStorage.removeItem(SLEUTEL);
    },
};

const GEWIJZIGD = 'organisaties-gewijzigd';

/**
 * De kiezer in de balk laadt zijn lijst één keer, bij het openen van de pagina. Wie
 * daarna een organisatie toevoegt, kon er dus pas na een herlaadbeurt naartoe. Deze
 * twee functies zijn het kortste bruggetje daartussen: het overzicht roept `meld`
 * aan, de balk luistert.
 */
export function meldOrganisatiesGewijzigd() {
    window.dispatchEvent(new Event(GEWIJZIGD));
}

/** Geeft een opruimfunctie terug, voor componentWillUnmount. */
export function bijOrganisatiesGewijzigd(luisteraar) {
    window.addEventListener(GEWIJZIGD, luisteraar);

    return () => window.removeEventListener(GEWIJZIGD, luisteraar);
}

/**
 * Stuurt de gekozen organisatie mee met elke API-aanroep. Dat gebeurt hier centraal,
 * zodat niet elke module dat apart hoeft te doen (en het nergens vergeten kan worden).
 */
export function stuurOrganisatieMee() {
    const origineel = window.fetch;

    window.fetch = function (verzoek, opties) {
        const url = typeof verzoek === 'string' ? verzoek : (verzoek && verzoek.url) || '';
        const gekozen = OrganisatieKeuze.get();

        if (gekozen && (url.startsWith('api/') || url.startsWith('/api/'))) {
            const instellingen = { ...(opties || {}) };
            instellingen.headers = { ...(instellingen.headers || {}), 'X-Organisatie': gekozen };
            return origineel(verzoek, instellingen);
        }

        return origineel(verzoek, opties);
    };
}
